import { motion } from "framer-motion";
import { MaskLine } from "../Reveal";
import ContactForm from "./ContactForm";
import { Mail, Phone, Instagram, Facebook } from "lucide-react";

const contacts = [
  {
    label: "Email",
    value: "wellness@jennie-marie.com",
    href: "mailto:wellness@jennie-marie.com",
    icon: Mail,
    testid: "contact-email",
  },
  {
    label: "Phone",
    value: "07859 932617",
    href: "tel:07859932617",
    icon: Phone,
    testid: "contact-phone",
  },
  {
    label: "Instagram",
    value: "@femalelifestylecoach",
    href: "https://www.instagram.com/femalelifestylecoach/?hl=en",
    icon: Instagram,
    testid: "contact-instagram",
  },
  {
    label: "Facebook",
    value: "Jennie-Marie · Lifestyle Consultant",
    href: "https://www.facebook.com/jenniemariefemalelifestyleconsultant",
    icon: Facebook,
    testid: "contact-facebook",
  },
];

export default function Contact() {
  return (
    <footer id="contact" data-testid="contact-section" className="relative bg-plum text-cream overflow-hidden">
      <div className="pointer-events-none absolute -top-24 -right-24 h-[420px] w-[420px] rounded-full bg-mne-pink/20 blur-[120px]" />
      <div className="pointer-events-none absolute bottom-0 -left-24 h-[380px] w-[380px] rounded-full bg-mne-blue/20 blur-[120px]" />

      <div className="relative max-w-[1400px] mx-auto px-6 md:px-10 pt-24 md:pt-32 pb-12">
        <p className="text-[11px] uppercase tracking-[0.3em] text-mne-pink mb-8">Begin Your Journey</p>

        <h2 className="font-serif font-light leading-[0.9] tracking-tight text-cream text-6xl sm:text-7xl md:text-8xl xl:text-[7rem]">
          <MaskLine>Let's build</MaskLine>
          <MaskLine className="italic text-mne-pink" delay={0.1}>your best</MaskLine>
          <MaskLine delay={0.2}>chapter yet.</MaskLine>
        </h2>

        <div className="mt-16 grid lg:grid-cols-12 gap-12 lg:gap-16">
          {/* Left: intro + contact links */}
          <div className="lg:col-span-5">
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9 }}
              className="text-lg text-cream/70 leading-relaxed max-w-md"
            >
              Ready to feel like yourself again? Book a free, no-pressure discovery call and we'll talk
              through where you are and how the MNE Formula can help you thrive.
            </motion.p>

            <div className="mt-12 space-y-8">
              {contacts.map((c) => {
                const Icon = c.icon;
                return (
                  <a
                    key={c.label}
                    data-testid={c.testid}
                    href={c.href}
                    target={c.href.startsWith("http") ? "_blank" : undefined}
                    rel="noopener noreferrer"
                    className="group block"
                  >
                    <div className="flex items-center gap-2 text-mne-pink/80">
                      <Icon size={16} strokeWidth={1.6} />
                      <span className="text-[11px] uppercase tracking-[0.2em]">{c.label}</span>
                    </div>
                    <p className="mt-2 text-lg text-cream/90 group-hover:text-cream transition-colors duration-300">
                      {c.value}
                    </p>
                    <span className="mt-1 block h-px w-0 bg-mne-pink transition-all duration-500 group-hover:w-full" />
                  </a>
                );
              })}
            </div>
          </div>

          {/* Right: form */}
          <div className="lg:col-span-7">
            <div className="rounded-[10px] border border-cream/15 bg-cream/[0.03] p-8 md:p-10 backdrop-blur-sm">
              <p className="text-[11px] uppercase tracking-[0.24em] text-mne-pink mb-8">Book your free discovery call</p>
              <ContactForm />
            </div>
          </div>
        </div>

        <div className="mt-20 flex flex-col md:flex-row items-center justify-between gap-6 border-t border-cream/15 pt-8">
          <img src="/assets/jennie-marie-logo.png" alt="Jennie-Marie" className="h-9 w-auto opacity-90" style={{ filter: "brightness(0) invert(1)" }} />
          <p className="text-[11px] tracking-[0.14em] text-cream/50 text-center">
            © {new Date().getFullYear()} Jennie-Marie Glover · Female Lifestyle Consultant · Mindset · Nutrition · Exercise
          </p>
        </div>
      </div>
    </footer>
  );
}
